var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoWhite = function SvgLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 65,
    viewBox: "0 0 66 65"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M48.554 37.873c3.003-1.912 5.013-5.252 4.97-9.036.068-5.901-4.856-10.73-10.757-10.73H28.35v18.946c0 2.785-1.935 4.471-4.322 4.471s-4.323-1.686-4.323-4.471V18.107h-7.839v17.915c0 7.91 5.445 12.459 12.162 12.459 6.716 0 12.16-4.55 12.16-12.46v-11.22h5.646c2.373 0 4.383 1.857 4.453 4.23a4.37 4.37 0 0 1-4.361 4.494h-4.712l9.298 14.387h8.535l-6.494-10.04zM65 32.5C65 50.45 50.449 65 32.5 65 14.55 65 0 50.45 0 32.5S14.55 0 32.5 0 65 14.55 65 32.5"
  })));
};
export default SvgLogoWhite;